import { CountryPreviewFragment } from "__generated__/graphql";

export const checkOptionEqualToValue = (
  option: CountryPreviewFragment,
  value: CountryPreviewFragment,
): boolean => {
  return option.code === value.code;
};
